import { TaskLabel } from "shared/types/task";
import { Clipboard, Report, Building, Award, Megaphone, Wrench, Computer, Users, Search, Bug, MailProposals, Home, Lock,  } from "../../assets/icons";

export const getIconForLabel = (label: TaskLabel) => {
    switch (label) {
      case TaskLabel.GENERAL:
        return <Clipboard />;
      case TaskLabel.LEGAL:
        return <Report />;
      case TaskLabel.FINANCE:
        return <Award />;
      case TaskLabel.CUSTOMER_SUPPORT:
        return <Megaphone />;
      case TaskLabel.RENOVATION:
        return <Building />;
      case TaskLabel.MAINTENANCE:
        return <Wrench />;
      case TaskLabel.IT:
        return <Computer />;
      case TaskLabel.BOARD:
        return <Users />;
      case TaskLabel.ACQUISITION:
        return <Search />;
      case TaskLabel.DUE_DIL:
        return <Bug />;
      case TaskLabel.MARKETING:
        return <MailProposals />;
      case TaskLabel.INSURANCES:
        return <Lock />
      case TaskLabel.RENT:
        return <Home />

      default:
        return null;
    }
  };